import fetch from "auth/FetchInterceptor";

const DssService = {};

DssService.fetch = function (params) {
  return fetch({
    url:
      "/fetchDss?start_date=" +
      params.startDate +
      "&end_date=" +
      params.endDate +
      "&paymentType=" +
      params.paymentType +
      "&cashier=" +
      params.cashier,
    method: "get",
    data: params,
  });
};

export default DssService;
